import { ReactComponent as AmazonIcon } from "../../assets/svgs/amazon.svg";
import { ReactComponent as MyntraIcon } from "../../assets/svgs/myntra.svg";
import { ReactComponent as FlipkartIcon } from "../../assets/svgs/flipkart.svg";
import { hasActiveAccount } from "./amazonAccountStore";

export const buildChannelConfig = (
  clientData,
  cursorData = {},
  clientId,
  setupTokens = []
) => {
  return [
  {
    id: "amazon",
    name: "Amazon Integration",
    icon: <AmazonIcon style={{ width: 18, height: 18 }} />,
    subConnections: [
      {
        id: "ads",
        name: "Connect Amazon Ads Portal",
        completed: !!clientData?.amazon_setup?.profile_info,
      },
      {
        id: "seller",
        name: "Connect Amazon Seller Portal",
        completed: hasActiveAccount("seller", setupTokens),
      },
      {
        id: "vendor",
        name: "Connect Amazon Vendor Portal",
        completed: hasActiveAccount("vendor", setupTokens),
      },
      {
        id: "AMAZON_LISTING_CSV_SYNC",
        name: "Upload Product Listing Data",
        completed:
          !!cursorData?.amazon?.find(
            (item) => item?.cursor_objective === "AMAZON_LISTING_CSV_SYNC"
          ) || !!clientData?.amazon_setup?.catalog_uploaded,
      },
      {
        id: "AMAZON_STATS_CSV_SYNC",
        name: "Upload Order Data",
        completed:
          !!cursorData?.amazon?.find(
            (item) => item?.cursor_objective === "AMAZON_STATS_CSV_SYNC"
          ) || !!clientData?.amazon_setup?.orders_uploaded,
      },
    ],
  },
  {
    id: "myntra",
    name: "Myntra Integration",
    icon: <MyntraIcon style={{ width: 18, height: 18 }} />,
    subConnections: [
      {
        id: "myntraAdsPortal",
        name: "Connect Myntra Ads Portal",
        completed:
          !!clientData?.myntra_setup?.b_account &&
          !!clientData?.myntra_setup?.profile_id,
      },
      {
        id: "MYNTRA_LISTING_CSV_SYNC",
        name: "Upload Product Listing Data",
        completed:
          !!cursorData?.myntra?.find(
            (item) => item?.cursor_objective === "MYNTRA_LISTING_CSV_SYNC"
          ),
      },
      {
        id: "MYNTRA_STATS_CSV_SYNC",
        name: "Upload Order Data",
        completed:
          !!cursorData?.myntra?.find(
            (item) => item?.cursor_objective === "MYNTRA_STATS_CSV_SYNC"
          ),
      },
    ],
  },
  {
    id: "flipkart",
    name: "Flipkart Integration",
    icon: <FlipkartIcon style={{ width: 18, height: 18 }} />,
    subConnections: [
      {
        id: "flipkartAdsPortal",
        name: "Connect Flipkart Ads Portal",
        completed:
          !!clientData?.flipkart_setup?.b_account &&
          !!clientData?.flipkart_setup?.profile_id,
      },
      {
        id: "FK_LISTING_CSV_SYNC",
        name: "Upload Product Listing Data",
        completed:
          !!cursorData?.flipkart?.find(
            (item) => item?.cursor_objective === "FK_LISTING_CSV_SYNC"
          ),
      },
      {
        id: "FK_STATS_CSV_SYNC",
        name: "Upload Order Data",
        completed:
          !!cursorData?.flipkart?.find(
            (item) => item?.cursor_objective === "FK_STATS_CSV_SYNC"
          ),
      },
    ],
  },
];
};
